import { AnyAction } from 'redux'
import { cloneDeep } from 'lodash';
import { FETCH_APPOINTMENTS, FETCH_ATENDIMENTOS_PACIENTE, FETCH_ATENDIMENTOS_STATUS_IMPRESSAO, FETCH_PRONTUARIO_LIMPAR, FETCH_PRONTUARIO_LIST, FETCH_ATENDIMENTO_STATUS_SALVAR  } from '../actions/appointment';
 
interface IAppointmentReducer{ 
    appointments: any[];
    atendimentosEmAberto: any[];
    atendimentos: any[];
    statusImpressao: string;
    statusSalvar: string;
    appointmentId: string;
    prontuarios: any[];
}
 
const initialState: IAppointmentReducer = {
    appointments: [],
    atendimentosEmAberto: [],
    atendimentos: [],
    statusImpressao: "",
    statusSalvar: "",
    appointmentId: "",
    prontuarios: []
} 
 
export const AppointmentReducer = (state = initialState, action: AnyAction) =>{
   switch(action.type){
        case FETCH_APPOINTMENTS:{
            return {
                ...cloneDeep(state),
                appointments: action.appointments
            }
        }
        case FETCH_ATENDIMENTOS_PACIENTE:{
            return {
                ...cloneDeep(state),
                atendimentosEmAberto: action.atendimentosEmAberto,
                atendimentos: action.atendimentos
            }
        }
        case FETCH_ATENDIMENTOS_STATUS_IMPRESSAO:{
            return {
                ...cloneDeep(state),
                statusImpressao: action.statusImpressao
            }
        }     
        case FETCH_PRONTUARIO_LIST:{
            return {
                ...cloneDeep(state),                
                prontuarios: action.prontuarios
            }
        }      
        case FETCH_PRONTUARIO_LIMPAR:{
            return {
                ...cloneDeep(state),                
                prontuarios: [],
            }
        }
        case FETCH_ATENDIMENTO_STATUS_SALVAR:{
            return {
                ...cloneDeep(state),
                statusSalvar: action.statusSalvar,
                appointmentId: action.appointmentId
            }
        } 
       default:{
           return state
       }
   }
}
 